import { ISettings } from "../models/settings";
import { getAuthorizationProperties } from "./authorizationHelper";

export async function getInactivitySettings() {
    const response = await fetch("/api/appStage/settings", {
        method: "GET",
        ...getAuthorizationProperties({
            "Content-Type": "application/json",
        }),
    });
    if (!response.ok) {
        throw new Error();
    }
    return await response.json() as ISettings;
}

export async function saveInactivitySettings(settings: ISettings) {
    const response = await fetch(`/api/appStage/settings`, {
        method: "POST",
        body: JSON.stringify(settings),
        ...getAuthorizationProperties({
            "Content-Type": "application/json",
        }),
    });
    if (!response.ok) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        });
    }
}
